<template>
  <div>
    <!-- 头部 -->
    <x-header :channel="channel" />

    <div class="background">
      <section class="container filters" style="margin-top: 86px;">
        <el-form :model="buyForm" :rules="rules" ref="buyForm">
          <div class="uid-input">
            <el-form-item prop="uid">
              <el-input :placeholder="`Uid example:111111`" v-model.number="buyForm.uid" class="uid-input-control" maxlength="10">
                <template slot="prepend">user</template>
              </el-input>
            </el-form-item>
          </div>
        </el-form>

        <div v-if="false" class="warning-text">
          <div role="alert" class="el-alert el-alert--error is-center is-light" style="background-color: #564c2a;">
            <i class="el-alert__icon el-icon-warning is-big" style="color: #e5c75c;"></i>
            <div class="el-alert__content">
              <p class="el-alert__description" style="color: #fffdf6;">
                Click the link below to contact us on telegram or WhatsApp if you encounter any problems when purchasing diamonds.
              </p>
              <p>
                <el-link type="primary" href="https://linktr.ee/pokermanapp" target="_blank" style="color: #e7cb6e;">https://linktr.ee/pokermanapp</el-link>
              </p>
              <i class="el-alert__closebtn el-icon-close" style="display: none;"></i>
            </div>
          </div>
        </div>
      </section>
      <section class="container list-section">
        <ul v-if="productList">
          <x-product v-for="(product, index) in productList" v-show="product.isShow" :key="index" :productIndex="index"
            :product="product" />
        </ul>
      </section>
    </div>

    <!-- 底部 -->
    <x-footer />
  </div>
</template>

<script>
import footer from '@/views/components/footer'
import header from '@/views/components/header'
import productItem from '@/views/shop/components/productItem'
import productConfig from '@/util/product'
import { userInfo } from '@/api/user'

export default {
  name: 'Home',
  components: {
    'x-header': header,
    'x-footer': footer,
    'x-product': productItem
  },
  props: {
    channel: String,
    default: ''
  },

  data () {
    return {
      productList: [],
      productInfo: {},
      buyForm: {
        uid: '',
        productId: ''
      },
      productCheckIndex: -1,
      rules: {
        uid: [
          { required: true, message: this.$t('recharge.index.uid_required_message'), trigger: 'blur' },
          { type: 'integer', message: this.$t('recharge.index.uid_message'), trigger: 'blur' }
        ]
      },
      productId: '',
      isTest: false
    }
  },
  mounted () {
    this.productList = productConfig

    this.isTest = this.$route.query.hasOwnProperty('env') && this.$route.query.env === '5mcqhztk'
    if (this.isTest) { }
  },
  methods: {
    productCheck (index) {
      this.$refs['buyForm'].validate(valid => {
        if (valid) {
          this.productCheckIndex = index
          this.buyForm.productId = this.productList[index].productId
          this.productInfo = this.productList[index]
        }
      })

      // this.buyForm)
      this.submit()
    },
    submit () {
      this.$refs['buyForm'].validate(valid => {
        if (valid) {
          this.submitBtnDisable = true
          if (!this.buyForm.productId) {
            this.$message({
              showClose: true,
              message: this.$t('recharge.common.check_produce_message'),
              type: 'error'
            })

            this.submitBtnDisable = false
            return false
          }

          let redireRouteName = 'Payment'
          if (this.channel === 'credit') {
            redireRouteName = 'creditPayment'
          }
          userInfo({ uid: this.buyForm.uid })
            .then(({ code, data }) => {
              if (data.uid) {
                let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
                userInfos[data.uid] = data
                window.localStorage.setItem('userinfos', JSON.stringify(userInfos))
                this.$router.push({
                  name: redireRouteName,
                  params: {
                    buyForm: this.buyForm,
                    productInfo: this.productInfo,
                    userInfo: data,
                    isTest: this.isTest
                  }
                })
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('recharge.common.user_not_found_message'),
                  type: 'error'
                })
              }
              this.submitBtnDisable = false
            })
            .catch((res) => {
              this.$message({
                showClose: true,
                message: this.$t('recharge.common.server_err'),
                type: 'error'
              })
              this.submitBtnDisable = false
            })
        } else {
          window.scrollTo(0, 0)
        }
      })
    }
  }

}
</script>

<!-- 覆盖样式 -->
<style>
.uid-input-control .el-input-group__prepend {
  color: #000000;
  background-image: url('~@/assets/images/shop/uid-button.png');
  background-size: cover;
  background-position: center;
  font-family: SourceHanSansCN-Regular;
  padding: 0 10px;
  border: none;
}

.uid-input-control .el-input__inner {
  background-color: #1c1f26;
  border: 1px solid #bba04b;
  color: #f6f7fa;
}

.uid-input-control .el-input__inner::placeholder {
  color: #474a50;
}

.el-form-item__error {
  text-align: center;
  right: 0;
}

.warning-text .el-alert__content {
  padding: 0 0;
}

.container {
  padding-right: 0px;
  padding-left: 0px;
}
</style>

<style scoped>
.background {
  background-image: url('~@/assets/images/shop/back.jpg');
  background-size: cover;
  background-position: center;
  width: 100%;
}

.filters {
  padding: 20px 0;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.list-section {
  max-width: 960px;
  padding-bottom: 60px;
}

.uid-input {
  width: 360px;
}

ul {
  list-style: none;
  display: flex;
  display: -moz-box;
  /* Firefox 17- */
  display: -webkit-flex;
  /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-flex;
  /* Firefox 18+ */
  display: -ms-flexbox;
  /* IE 10 */
  flex-wrap: wrap;
  padding: 0;
  margin: 0 auto;
}

.error {
  color: red;
  text-align: center;
}

.error h3 {
  font-size: 18px;
  font-weight: 800;
}

@media only screen and (max-width: 970px) {

  .warning-text {
    width: 560px;
  }

  .list-section {
    max-width: 630px;
    padding-bottom: 60px;
  }
}

@media only screen and (max-width: 768px) {

  .warning-text {
    width: 560px;
  }

  .list-section {
    max-width: 650px;
    padding-bottom: 60px;
  }
}

@media only screen and (max-width: 630px) {
  .filters {
    max-width: 360px;
  }

  .warning-text {
    width: 360px;
  }

  .list-section {
    max-width: 360px;
  }
}

@media only screen and (max-width: 560px) {
  .filters {
    max-width: 360px;
  }

  .warning-text {
    width: 360px;
  }

  .list-section {
    max-width: 360px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shop/index.vue